import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { Grid } from '@mui/material';


const AntSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : 'rgb(30,60,114)',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

const PermissionElevationModal = ({open,close,modelOpenRequestType,permissions}) => {
  
  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
        <DialogTitle>{ modelOpenRequestType === 'current' ? 'Current Permissions' : 'Requested Permissions' }</DialogTitle>
            <DialogContent dividers> 
              {permissions?.data?.map((permission) => {
                return (
                  <Grid container sx={{ marginBottom:'6px',paddingBottom:'8px',paddingTop:'8px',background:'#f9f9f9',     display: 'flex', justifyContent: 'space-between'}}>
                    <label>{permission.permission_name}</label>
                    <AntSwitch
                      key={permission.id}
                      checked={modelOpenRequestType === 'current' ? true : false }
                      value={permission.id || ''}
                      inputProps={{ 'aria-label': 'controlled' }} 
                    />
                  </Grid>
                )
              })}
            </DialogContent>
            <DialogActions>
                <Button  
                    variant="contained"
                    size="medium"
                    color="error" 
                    onClick={close}
                >Close</Button>
            </DialogActions>
        </Dialog> 
  )
}

export default PermissionElevationModal